import produce from 'immer';

const INITIAL_STATE = {
  user: null,
  loading: false
};

export default (state = INITIAL_STATE, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case '@auth/COMPLETE_PASSWORD_REQUEST':
        draft.loading = true;
        break;

      case '@auth/COMPLETE_PASSWORD_SUCCESS':
        draft.user = action.payload.user;
        draft.loading = false;
        break;

      default:
    }
  });
};
